import React, { useState } from 'react'
import Main from './Main'
import { useTranslation } from 'react-i18next';
import Register from './Register';
import SignIn from '@pages/auth/SignIn';


function Home({ handleLogin }) {
  const { t } = useTranslation();

  const [show, setShow] = useState(false);
  const [activeForm, setActiveForm] = useState("in");
  const openModal = (formType = "in") => {
    setActiveForm(formType);
    setShow(true);
  }
   const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      fontFamily: "'Segoe UI', sans-serif",
      padding: "20px",
    },
    card: {
      background: "white",
      borderRadius: "20px",
      padding: "50px 40px",
      maxWidth: "500px",
      width: "100%",
      textAlign: "center",
      boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
    },
    title: {
      fontSize: "28px",
      fontWeight: "700",
      color: "#2d3748",
      margin: "10px 0 15px 0",
    },
    subtitle: {
      fontSize: "16px",
      color: "#718096",
      lineHeight: "1.6",
      margin: "0",
    },
  };
  return (
    <div style={styles.container}>
   {/* <div className=" " > */}
   
      {/* <Main openModal={openModal} />
      <Register
        show={show}
        setShow={setShow}
        handleLogin={handleLogin}
        activeForm={activeForm}
        setActiveForm={setActiveForm}
      />
      <section
        className="py-5 border-bottom bg-dark"
        style={{ background: "rgba(255,255,255,0.03)", borderColor: "rgba(255,255,255,0.05)" }}
      >
        <div className="container">
          <p
            className="text-center text-secondary mb-3"
            style={{ fontSize: "0.9rem", letterSpacing: "2px" }}
          >
            TRUSTED BY LEADING TRAVEL COMPANIES
          </p>

          <div className="row g-4 align-items-center justify-content-center text-center">
            {["Expedia", "Booking", "hotelbeds", "Amadeus", "Mystifly"].map((brand) => (
              <div key={brand} className="col-4 col-md-2">
                <span
                  className="fw-bold"
                  style={{ fontSize: "1.5rem", opacity: 0.4, color: "white" }}
                >
                  {brand}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>  */}
           <div style={styles.card}>
        <div style={{ fontSize: "60px", marginBottom: "10px" }}>🔧</div>
        <p style={styles.title}>{t("back_soon")}</p>
        <p style={styles.subtitle}>{t("maintenance_caption")}</p>
      </div>

    </div>
  )
}

export default Home